import axios from 'axios';
import { refreshExpiredToken } from './UserAPI';

const $host = axios.create({
        proxy: process.env.REACT_APP_API_URL,
    }
);

$host.defaults.withCredentials = true

$host.interceptors.response.use(res => res, async err => {
    const {response} = err
    if (response?.data && response?.data.error.indexOf("Refresh Token") > 0) {
        console.log(err.request)
        return Promise.reject(err)
    }
    if (err.status === 401 ) {
        await refreshExpiredToken()
        return $host.request(err.request)
    }
})

// обработка ошибки получения данных API
const handleError = (error) => {
    console.error(`Ошибка при получении данных: ${error.message}`);
    throw error;
};
// статус ответа API 
const handleResponse = (res) => {
    if (res.status >= 200 && res.status < 300) {
        return res.data;
    } else {
        console.error(`Ошибка ${res.status}`);
        throw new Error(`Request failed with status ${res.status}`);
    }
};

export {
    $host, handleError, handleResponse
}